import * as constants from '../constants';

export interface CancelEditMessage {
  type: constants.CANCEL_EDIT_MESSAGE;
}

export const cancelEditMessage = (): CancelEditMessage => {
  return {
    type: constants.CANCEL_EDIT_MESSAGE,
  };
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/cancelEditMessage.ts